import React, {Component} from 'react';
import ScenarioProjects from "./ScenarioProjects/ScenarioProjects";
import {connect} from "react-redux";
import {Button} from "reactstrap";
import {DRSceanrioProjectDataCreating} from "./ScenarioProjects/helpers";
import {
  createProjectScenario,
  editDealroomProjectScenario,
  getDealroomProjects, getDealroomProjectsScenarios, getScenarioProjects,
  projectErrorsObjSet
} from "../../../store/actions";
import {validationCheck} from "../../helpers";
import {NotificationManager} from "react-notifications";

class DealroomScenarioProjects extends Component {
  state = {
    projectsData: [],
  };

  keepProjectData = (data, index) => {
    let projectsData = this.state.projectsData;
    projectsData[index] = data;
    this.setState({projectsData})
  };

  saveScenario = () => {
    const {projects, dealroomId, name, createProjectScenario,
      projectsErrors, getScenarioProjects, projectErrorsObjSet,
      NotificationManager,
      getDealroomProjectsScenarios, removeChoosenProjects,changeTab,dealroomProjectsScenariosLength} = this.props;
    const {projectsData} = this.state;
    let flag = false;
    const result = {
      dealroom: dealroomId,
      scenario_projects: [],
      name,
    };


    projectsErrors.map((errorObj) => {
      if (validationCheck(errorObj)) {
        flag = true;
      }
    });

    if (!flag) {
      projects.map((project, i) => {
        result.scenario_projects.push(DRSceanrioProjectDataCreating(projectsData[i], project));
      });
      createProjectScenario(result).then((res) => {
        getScenarioProjects(res.data.detail).then((res)=> {
          projectErrorsObjSet(res.payload.user_projects.length);
        });
        getDealroomProjectsScenarios(dealroomId);
        removeChoosenProjects('choosenProjects', []);
        NotificationManager.success('Scenario successfuly saved', "", 5000)
        changeTab(dealroomProjectsScenariosLength,'activeProjectTab')
      });
    }
  };

  editScenario = () => {
    const {
      projects, dealroomId,
      editDealroomProjectScenario,
      projectsErrors, choosenProjectScenarioData,
      NotificationManager
    } = this.props;
    const {projectsData} = this.state;
    let flag = false;
    const result = {
      dealroom: dealroomId,
      scenario_projects: [],
      name: choosenProjectScenarioData.name,
    };


    projectsErrors.map((errorObj) => {
      if (validationCheck(errorObj)) {
        flag = true;
      }
    });
    if (!flag) {
      projects.map((project, i) => {
        result.scenario_projects.push(DRSceanrioProjectDataCreating(projectsData[i], project));
      });
      editDealroomProjectScenario(result, choosenProjectScenarioData.id)
        .then(() => {
          NotificationManager.success('Scenario successfuly edited', "", 5000)
      });
    }

  };

  render() {
    const {projects, newProjectScenarioCreating} = this.props;

    return (
      <React.Fragment>
        <div style={{marginBottom: '20px'}}>
          <h1>Scenario Projects</h1>
          {projects.map((project, i) => {
            return (<div key={i}
                         style={{
                           display: 'flex',
                           alignItems: 'center',
                           justifyContent: 'space-between'
                         }}>

              <ScenarioProjects project={project}
                                keepProjectData={this.keepProjectData}
                                changeProjectData={this.changeProjectData}
                                projectIndex={i}/>

            </div>)
          })}
          {newProjectScenarioCreating ?
            <Button color="primary" style={{float: 'right'}} onClick={this.saveScenario}> SAVE SCENARIO </Button>
            : <Button color="primary" style={{float: 'right'}} onClick={this.editScenario}> EDIT SCENARIO</Button>
          }
        </div>


      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    newProjectScenarioCreating: state.dealroom.newProjectScenarioCreating,
    projectsErrors: state.projects.projectsErrors,
    name: state.schemas.name,
    choosenProjectScenarioData: state.dealroom.choosenProjectScenarioData,
  }
};

export default connect(mapStateToProps, {
  createProjectScenario,
  editDealroomProjectScenario,
  getDealroomProjects,
  projectErrorsObjSet,
  getDealroomProjectsScenarios,
  getScenarioProjects
})(DealroomScenarioProjects);


// WEBPACK FOOTER //
// ./src/views/Dealroom/Dealroom/DealroomScenarioProjects.js